import styles from './WizardFooter.module.css';

function WizardFooter({
    onPrevious,
    onNext,
    nextDisabled = false,
    nextLabel = 'Next',
    previousLabel = 'Back',
    showPrevious = true,
    isPrimaryAction = false,
    onDelete = null,
    deleteDisabled = false,
    deleteLabel = 'Delete',
}) {
    return (
        <div className={styles.wizardFooter}>
            <div className={styles.footerContent}>
                {showPrevious && onPrevious && (
                    <button
                        onClick={onPrevious}
                        className={styles.footerButton}
                    >
                        ← {previousLabel}
                    </button>
                )}
                {!showPrevious && <div></div>}
                <div className={styles.footerActions}>
                    {onDelete && (
                        <button
                            onClick={onDelete}
                            disabled={deleteDisabled}
                            className={styles.deleteButton}
                        >
                            {deleteLabel}
                        </button>
                    )}
                    <button
                        onClick={onNext}
                        disabled={nextDisabled}
                        className={`${styles.footerButton} ${isPrimaryAction ? styles.primaryButton : ''}`}
                    >
                        {nextLabel} {isPrimaryAction ? '' : '→'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default WizardFooter;
